/* MyRealDolls two Featured Brands rows: dependency-free carousel.
   Native touch swipe and scroll snap work even if JS or Slick is blocked. */
(function () {
  'use strict';
  function initialize(section) {
    if (!section || section.hasAttribute('data-mrd-brands-ready')) return;
    var track = section.querySelector('.mrd-brand-carousel__track');
    var prev = section.querySelector('.mrd-brand-carousel__prev');
    var next = section.querySelector('.mrd-brand-carousel__next');
    if (!track || !prev || !next) return;
    section.setAttribute('data-mrd-brands-ready', 'true');
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var visible = !('IntersectionObserver' in window);
    var paused = false;
    var lastInteraction = 0;

    function visibleCount() {
      if (window.innerWidth <= 767) return 2;
      if (window.innerWidth <= 1023) return 3;
      return 5;
    }
    function step() {
      var item = track.querySelector('.home-logo-list__item');
      if (!item) return track.clientWidth;
      var width = item.getBoundingClientRect().width;
      var gap = window.getComputedStyle ? parseFloat(window.getComputedStyle(track).columnGap) || 0 : 0;
      return (width + gap) * visibleCount();
    }
    function move(direction, fromUser) {
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      if (max < 2) return;
      if (fromUser) lastInteraction = Date.now();
      var atStart = track.scrollLeft <= 3;
      var atEnd = track.scrollLeft >= max - 3;
      var left = direction > 0 && atEnd ? 0 :
        direction < 0 && atStart ? max :
        Math.max(0, Math.min(max, track.scrollLeft + direction * step()));
      track.scrollTo({left: left, behavior: reducedMotion ? 'auto' : 'smooth'});
    }
    prev.addEventListener('click', function () { move(-1, true); });
    next.addEventListener('click', function () { move(1, true); });
    track.addEventListener('pointerdown', function () { lastInteraction = Date.now(); }, {passive: true});
    track.addEventListener('wheel', function () { lastInteraction = Date.now(); }, {passive: true});
    section.addEventListener('mouseenter', function () { paused = true; });
    section.addEventListener('mouseleave', function () { paused = false; });
    section.addEventListener('focusin', function () { paused = true; });
    section.addEventListener('focusout', function (e) {
      if (!section.contains(e.relatedTarget)) paused = false;
    });
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        visible = !!(entries[0] && entries[0].isIntersecting);
      }, {threshold: .2});
      observer.observe(section);
    }
    if (!reducedMotion) {
      window.setInterval(function () {
        if (visible && !paused && !document.hidden && Date.now() - lastInteraction > 8500) {
          move(1, false);
        }
      }, 5000);
    }
  }
  function initAll(root) {
    (root || document).querySelectorAll('.mrd-brand-carousel').forEach(initialize);
    if (root && root.matches && root.matches('.mrd-brand-carousel')) initialize(root);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, {once: true});
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
